import { IconProps } from "@chakra-ui/react";
import BaselinePeopleOutline from "./Iconify/BaselinePeopleOutline";

export default function CaminoBuddyIcon(props: IconProps) {
  return <BaselinePeopleOutline {...props} />;
}
